import React, { useState } from 'react';
import { XCircle, CheckCircle2, Crown, ChevronLeft, ChevronRight, TrendingUp, Users, Layers, Target } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { FadeIn } from './ui/FadeIn';
const slides = [{
  title: 'Estancamiento crónico en habilidades de élite',
  label: 'Rompé la meseta',
  icon: TrendingUp,
  image: 'https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=800&q=80&auto=format&fit=crop',
  sin: 'Repetís siempre los mismos intentos a la plancha full y te frustrás al no ver avances.',
  con: 'Sistema avanzado de micro-ciclos y bandas de resistencia para romper la meseta en trucos de nivel A y B.'
}, {
  title: 'Querés empezar a coachear a otros atletas',
  label: 'Convertí tu pasión en ingresos',
  icon: Users,
  image: 'https://images.unsplash.com/photo-1599058917765-a780eda07a3e?w=800&q=80&auto=format&fit=crop',
  sin: 'No tenés un sistema validado para enseñar lo que vos ya lograste a personas con distinta genética.',
  con: 'Guía completa de metodología de enseñanza, corrección de errores comunes y armado de rutinas para terceros.'
}, {
  title: 'Necesitás dominar combos y transiciones',
  label: 'Freestyle de competencia',
  icon: Layers,
  image: 'https://images.unsplash.com/photo-1581009146145-b5ef050c2e1e?w=800&q=80&auto=format&fit=crop',
  sin: 'Hacés los trucos aislados pero te quedás sin aire o perdés la forma al intentar unirlos.',
  con: 'Sistema paso a paso para encadenar isométricos con dinámicos creando combos fluidos de nivel competencia.'
}, {
  title: 'Falta de diagnóstico biomecánico personal',
  label: 'Encontrá tu eslabón débil',
  icon: Target,
  image: 'https://images.unsplash.com/photo-1594737625785-a6cbdabd333c?w=800&q=80&auto=format&fit=crop',
  sin: 'No sabés si te falta fuerza de core, retracción escapular o movilidad de muñecas para destrabar tu movimiento.',
  con: 'Protocolo de auto-diagnóstico avanzado para identificar tu eslabón débil y atacarlo directamente.'
}];
export function ProEliteUpsell() {
  const [activeIndex, setActiveIndex] = useState(0);
  const [direction, setDirection] = useState(0);
  const next = () => {
    setDirection(1);
    setActiveIndex(prev => (prev + 1) % slides.length);
  };
  const prev = () => {
    setDirection(-1);
    setActiveIndex(prev => (prev - 1 + slides.length) % slides.length);
  };
  const goTo = (i: number) => {
    setDirection(i > activeIndex ? 1 : -1);
    setActiveIndex(i);
  };
  const slide = slides[activeIndex];
  const Icon = slide.icon;
  return <section className="py-14 md:py-24 bg-brand-card border-y border-brand-border relative overflow-hidden" data-id="element-250">
      <div className="container mx-auto px-4 max-w-5xl relative z-10" data-id="element-251">
        <FadeIn className="text-center mb-8 md:mb-12" data-id="element-252">
          <Crown className="w-10 h-10 md:w-12 md:h-12 text-brand-orange mx-auto mb-4" data-id="element-253" />
          <h2 className="text-3xl md:text-5xl mb-3" data-id="element-254">
            ¿QUÉ AGREGA EL{' '}
            <span className="text-brand-orange" data-id="element-255">CALISTENIA PRO ÉLITE™</span>?
          </h2>
          <p className="text-base md:text-lg text-brand-muted max-w-2xl mx-auto" data-id="element-256">
            Para atletas que quieren ir un paso más allá (Competencia o
            Coaching)
          </p>
        </FadeIn>

        {/* Carousel */}
        <FadeIn delay={0.15} data-id="element-257">
          <div className="bg-brand-dark border border-brand-border rounded-2xl overflow-hidden shadow-[0_0_40px_rgba(255,107,26,0.08)]" data-id="element-258">
            <div className="grid md:grid-cols-2 min-h-[420px] md:min-h-[380px]" data-id="element-259">
              {/* Image side */}
              <div className="relative h-48 md:h-auto overflow-hidden bg-brand-dark order-1 md:order-1" data-id="element-260">
                <AnimatePresence mode="wait" custom={direction} data-id="element-261">
                  <motion.div key={activeIndex} initial={{
                  opacity: 0,
                  scale: 1.05
                }} animate={{
                  opacity: 1,
                  scale: 1
                }} exit={{
                  opacity: 0,
                  scale: 1.05
                }} transition={{
                  duration: 0.4
                }} className="absolute inset-0" data-id="element-262">
                    <img src={slide.image} alt={slide.title} className="w-full h-full object-cover" data-id="element-263" />
                    <div className="absolute inset-0 bg-gradient-to-t md:bg-gradient-to-r from-brand-dark via-brand-dark/40 to-transparent" data-id="element-264" />
                  </motion.div>
                </AnimatePresence>

                {/* Slide counter overlay */}
                <div className="absolute top-3 left-3 bg-brand-dark/80 backdrop-blur-sm border border-brand-border rounded-md px-2.5 py-1 z-10" data-id="element-265">
                  <span className="text-xs font-display tracking-widest text-brand-orange" data-id="element-266">
                    {String(activeIndex + 1).padStart(2, '0')} /{' '}
                    {String(slides.length).padStart(2, '0')}
                  </span>
                </div>
              </div>

              {/* Content side */}
              <div className="p-5 md:p-8 flex flex-col justify-between order-2 md:order-2" data-id="element-267">
                <AnimatePresence mode="wait" custom={direction} data-id="element-268">
                  <motion.div key={activeIndex} initial={{
                  opacity: 0,
                  x: direction * 20
                }} animate={{
                  opacity: 1,
                  x: 0
                }} exit={{
                  opacity: 0,
                  x: -direction * 20
                }} transition={{
                  duration: 0.3
                }} data-id="element-269">
                    {/* Icon + label */}
                    <div className="flex items-center gap-2 mb-3" data-id="element-270">
                      <div className="bg-brand-orange/15 p-1.5 rounded" data-id="element-271">
                        <Icon className="w-4 h-4 text-brand-orange" data-id="element-272" />
                      </div>
                      <span className="text-xs uppercase tracking-widest text-brand-orange font-bold" data-id="element-273">
                        {slide.label}
                      </span>
                    </div>

                    <h3 className="text-lg md:text-2xl font-bold leading-tight mb-5" data-id="element-274">
                      {slide.title}
                    </h3>

                    {/* SIN/CON compact */}
                    <div className="space-y-2.5 mb-6" data-id="element-275">
                      <div className="flex items-start gap-2.5 bg-red-500/5 border border-red-500/15 rounded-lg p-3" data-id="element-276">
                        <XCircle className="w-4 h-4 text-red-500 shrink-0 mt-0.5" data-id="element-277" />
                        <div data-id="element-278">
                          <span className="text-[10px] font-bold text-red-500 uppercase tracking-wider block" data-id="element-279">
                            Sin Pro Élite
                          </span>
                          <p className="text-xs md:text-sm text-brand-muted leading-snug mt-0.5" data-id="element-280">
                            {slide.sin}
                          </p>
                        </div>
                      </div>
                      <div className="flex items-start gap-2.5 bg-brand-orange/5 border border-brand-orange/20 rounded-lg p-3" data-id="element-281">
                        <CheckCircle2 className="w-4 h-4 text-brand-orange shrink-0 mt-0.5" data-id="element-282" />
                        <div data-id="element-283">
                          <span className="text-[10px] font-bold text-brand-orange uppercase tracking-wider block" data-id="element-284">
                            Con Pro Élite
                          </span>
                          <p className="text-xs md:text-sm text-brand-text leading-snug mt-0.5" data-id="element-285">
                            {slide.con}
                          </p>
                        </div>
                      </div>
                    </div>
                  </motion.div>
                </AnimatePresence>

                {/* Carousel Nav */}
                <div className="flex items-center justify-between border-t border-brand-border/60 pt-4" data-id="element-286">
                  <button onClick={prev} aria-label="Slide anterior" className="w-9 h-9 rounded-full bg-brand-card border border-brand-border hover:border-brand-orange hover:text-brand-orange transition-colors flex items-center justify-center text-brand-muted" data-id="element-287">
                    <ChevronLeft className="w-4 h-4" data-id="element-288" />
                  </button>

                  <div className="flex gap-1.5" data-id="element-289">
                    {slides.map((_, i) => <button key={i} onClick={() => goTo(i)} aria-label={`Ir al slide ${i + 1}`} className={`h-1.5 rounded-full transition-all duration-300 ${i === activeIndex ? 'w-8 bg-brand-orange' : 'w-1.5 bg-brand-border hover:bg-brand-muted'}`} data-id="element-290" />)}
                  </div>

                  <button onClick={next} aria-label="Slide siguiente" className="w-9 h-9 rounded-full bg-brand-orange text-white hover:bg-brand-orangeHover transition-colors flex items-center justify-center" data-id="element-291">
                    <ChevronRight className="w-4 h-4" data-id="element-292" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </FadeIn>

        {/* Includes section - compact */}
        <FadeIn delay={0.3} className="mt-8 md:mt-12" data-id="element-293">
          <div className="bg-gradient-to-br from-brand-dark to-brand-card border border-brand-orange/30 rounded-2xl p-5 md:p-8" data-id="element-294">
            <h3 className="text-xl md:text-2xl font-display text-brand-orange mb-5 text-center tracking-wide" data-id="element-295">
              CALISTENIA PRO ÉLITE™ INCLUYE:
            </h3>
            <div className="grid md:grid-cols-2 gap-4" data-id="element-296">
              <div className="flex gap-3 bg-brand-card/50 border border-brand-border/50 rounded-lg p-4" data-id="element-297">
                <div className="bg-brand-orange/20 p-2 rounded-lg h-fit shrink-0" data-id="element-298">
                  <span className="font-display text-lg text-brand-orange" data-id="element-299">
                    M1
                  </span>
                </div>
                <div data-id="element-300">
                  <h4 className="font-bold text-sm md:text-base mb-1" data-id="element-301">
                    Sistema de Programación de Élite
                  </h4>
                  <p className="text-brand-muted text-xs md:text-sm" data-id="element-302">
                    Ciclos de hipertrofia funcional, fuerza máxima y descarga
                    neuronal.
                  </p>
                </div>
              </div>
              <div className="flex gap-3 bg-brand-card/50 border border-brand-border/50 rounded-lg p-4" data-id="element-303">
                <div className="bg-brand-orange/20 p-2 rounded-lg h-fit shrink-0" data-id="element-304">
                  <span className="font-display text-lg text-brand-orange" data-id="element-305">
                    M2
                  </span>
                </div>
                <div data-id="element-306">
                  <h4 className="font-bold text-sm md:text-base mb-1" data-id="element-307">
                    El Negocio del Entrenamiento
                  </h4>
                  <p className="text-brand-muted text-xs md:text-sm" data-id="element-308">
                    Cómo convertir tu conocimiento en asesorías online
                    rentables.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}